(()=>{
  if (window.__variantSyncDebug === undefined) window.__variantSyncDebug = true;
  function log(){ try{ if (window.__variantSyncDebug) {} }catch(e){} }

  function getPicker(sectionId){
    return document.getElementById('variant-radios-'+sectionId) || document.getElementById('variant-selects-'+sectionId);
  }

  function parseVariants(container){
    try{ const el = container.querySelector('script[type="application/json"]');
      return el ? JSON.parse(el.textContent.trim()) : []; } catch(e){ return []; }
  }

  function getSelected(container){
    const vals=[];
    const radios = container.querySelectorAll('fieldset.product-form__input input[type="radio"]:checked');
    if (radios.length){ radios.forEach(i=>vals.push(i.value)); }
    else { container.querySelectorAll('select[name^="options["]').forEach(s=>vals.push(s.value)); }
    return vals;
  }

  function findVariant(variants, selected){
    for (let i=0;i<variants.length;i++){
      const v = variants[i];
      const arr = [v.option1,v.option2,v.option3].filter(Boolean);
      let ok = true;
      for (let j=0;j<selected.length;j++){ if (selected[j]!==arr[j]) { ok=false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function jumpToMedia(sectionId, mediaId){
    if (!mediaId) return;
    const thumbId = 'Slide-Thumbnail-'+sectionId+'-'+mediaId;
    const thumb = document.getElementById(thumbId);
    if (thumb){
      thumb.click();
      const thumbsWrap = document.getElementById('Slider-Thumbnails-'+sectionId);
      const mainWrap = document.getElementById('Slider-Gallery-'+sectionId);
      if (thumbsWrap && thumbsWrap.swiper){
        const slides = Array.from(thumbsWrap.querySelectorAll('.swiper-slide'));
        const idx = slides.indexOf(thumb);
        if (idx >= 0) {
          try { thumbsWrap.swiper.slideTo(idx); } catch(e){}
          if (mainWrap && mainWrap.swiper) { try { mainWrap.swiper.slideTo(idx); } catch(e){} }
        }
      }
      return;
    }
    const main = document.querySelector('[data-media-id="'+sectionId+'-'+mediaId+'"]') || document.getElementById('Slide-'+sectionId+'-'+mediaId);
    if (main && main.scrollIntoView) main.scrollIntoView({behavior:'smooth', block:'center'});
  }

  function wireSection(section){
    const fromDataset = section.dataset && (section.dataset.section || section.dataset.sectionId);
    const fromAttr = section.getAttribute && (section.getAttribute('data-section') || section.getAttribute('data-section-id'));
    const fromIdMatch = /ProductInfo-(.+)/.exec(section.id || '')
    const sectionId = fromDataset || fromAttr || (fromIdMatch ? fromIdMatch[1] : section.id);
    log('[VariantSync] wireSection -> candidates', { fromDataset, fromAttr, id: section.id, resolved: sectionId });
    if (!sectionId) return;
    const picker = getPicker(sectionId);
    if (!picker) { log('[VariantSync] picker not found for section', sectionId); return; }
    const effectiveId = picker.getAttribute('data-section') || sectionId;
    log('[VariantSync] effective section id:', effectiveId);
    const variants = parseVariants(picker);
    if (!variants.length) { log('[VariantSync] variants empty'); return; }
    const handler = ()=>{
      const sel = getSelected(picker);
      const v = findVariant(variants, sel);
      const mediaId = v && v.featured_media && v.featured_media.id;
      jumpToMedia(effectiveId, mediaId);
      log('[VariantSync] change ->', { selected: sel, variantId: v && v.id, mediaId, sectionId: effectiveId });
    };
    picker.addEventListener('change', handler);
    section.addEventListener('click', e=>{
      const t=e.target;
      if (t.tagName==='INPUT'||t.tagName==='SELECT'||t.closest('label')) setTimeout(handler,0);
    });
    handler();
  }

  function init(){
    const sections = document.querySelectorAll('product-info[id^="ProductInfo-"], .product__info-container, [data-section], [data-section-id]');
    log('[VariantSync] init. sections found:', sections.length);
    sections.forEach(s=>wireSection(s));

    // Theo dõi DOM (Theme editor/async mounts)
    const mo = new MutationObserver((muts)=>{
      muts.forEach(m=>{
        m.addedNodes && m.addedNodes.forEach(n=>{
          if (!(n instanceof HTMLElement)) return;
          if (n.matches && (n.matches('product-info, .product__info-container, [data-section], [data-section-id]'))){
            wireSection(n);
          }
          n.querySelectorAll && n.querySelectorAll('product-info, .product__info-container, [data-section], [data-section-id]').forEach(wireSection);
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


